import { useEffect } from 'react'

import { SearchContextState } from '@elastic/react-search-ui/lib/cjs/withSearch'
import { helpers } from '@elastic/search-ui'
import { useQuery, useQueryClient } from 'react-query'

import { getAttributions } from 'app/services/Api/listing'
import { removeSearchAttributeFilters } from 'app/utils/helpers/elastic.helpers'

const { findFilterValues } = helpers

type UseSearchAttributeFiltersProps = Pick<
  SearchContextState,
  'filters' | 'removeFilter'
> & {
  searchCategoryId?: string
}

const useSearchAttributeFilters = ({
  filters,
  removeFilter,
  searchCategoryId
}: UseSearchAttributeFiltersProps) => {
  const queryClient = useQueryClient()

  const filterCategoryId = findFilterValues(
    filters || [],
    'category_id.keyword',
    'any'
  )?.[0] as string
  const subCategoryId = findFilterValues(
    filters || [],
    'sub_category_id.keyword',
    'any'
  )?.[0] as string

  const categoryId = filterCategoryId ?? searchCategoryId

  const categories = queryClient.getQueryData<Category[]>([
    'options',
    'category'
  ])

  const isAttributionsPresent = !!categories?.find(
    (category) => String(category.id) === categoryId
  )?.attributions_present

  const { data: attributions } = useQuery<Attribution[]>(
    [categoryId],
    () => getAttributions({ by_category_id: categoryId }),
    { enabled: !!categoryId && isAttributionsPresent }
  )

  useEffect(() => {
    if (subCategoryId) return

    removeSearchAttributeFilters({ filters, removeFilter })
  }, [subCategoryId])

  return { isAttributionsPresent, attributions }
}

export default useSearchAttributeFilters
